module.exports = __webpack_public_path__ + "static/media/YM56_4.34ce75e5.jpg";